import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferViewFormInterface } from './aquifer-test-details-view'

export default function TestAnalysisEditForm({ fields, isLoading }: AquiferViewFormInterface & { wellId: string }) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Test analysis
      </Heading>
      <FormField isSkeleton={isLoading} label='Analysis method' labelId='analysisMethodLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='analysisMethodLabel'
          value={`${fields.analysisMethod ?? ''}`}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.testAnalysisPerson}
        isSkeleton={isLoading}
        label='Test analysis by'
        labelId='testAnalysisPersonLabel'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='testAnalysisPersonLabel'
          value={`${fields.testAnalysisPerson ?? ''}`}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.reportNo}
        isSkeleton={isLoading}
        label='Report reference'
        labelId='reportReferenceLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='reportReferenceLabel' value={`${fields.reportNo ?? ''}`} />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.dataReference}
        isSkeleton={isLoading}
        label='Data reference'
        labelId='dataReferenceLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='dataReferenceLabel' value={`${fields.dataReference ?? ''}`} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.testReviewedByPerson}
        isSkeleton={isLoading}
        label='Test reviewed by'
        labelId='testReviewedByPersonLabel'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='testReviewedByPersonLabel'
          value={`${fields.testReviewedByPerson ?? ''}`}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Test review date' labelId='testReviewDateLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='testReviewDateLabel'
          value={`${fields.testReviewDate ?? ''}`}
        />
      </FormField>
    </>
  )
}
